export default {
  main: '#EDEAE6',
  secondary: '#002855',
  contrastingColor: '#000000',
  priceColor: '#BA0C2F',
  entryBackground: '#EDEAE6',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
